package com.mgacreative.hotel.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RoomPosition(
    val id: String? = null,
    @SerialName("tenant_id") val tenantId: String,
    @SerialName("room_id") val roomId: String,
    @SerialName("floor_number") val floorNumber: Int,
    @SerialName("pos_x") val posX: Float = 50f,
    @SerialName("pos_y") val posY: Float = 50f,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null
)
